import React from 'react'
import Link from 'next/link'
import { useSearchParams } from 'next/navigation'
import { Button } from '@/components/ui/button'

import { useQueryParams } from '~/hooks/useQueryParams'
import { trpc } from '~/utils/api'
import FilterList from './FilterList'

interface Props {
  onPressBack: () => void
}

const Filters: React.FC<Props> = ({ onPressBack }) => {
  const searchParams = useSearchParams()
  const { data: filterData } = trpc.stories.categories.useQuery()

  const { list: categoryList, setParams: setCategoryParams } =
    useQueryParams('categories')

  const handleSelectCategories = (newlySelectCategories: string[]) => {
    setCategoryParams(newlySelectCategories)
  }

  const { list: timeFrame, setParams: setTimeFrame } =
    useQueryParams('time_frame')

  const onSelectedTimeFrame = (newlySelectedTimeFrame: number[]) => {
    setTimeFrame(newlySelectedTimeFrame)
  }

  return (
    <div className='m-auto flex h-max w-[90%] max-w-[800px] flex-col items-center bg-white px-9 py-6 sm:px-16 sm:py-12'>
      <h1 className='text-center text-xl font-bold text-black'>
        Filter the results
      </h1>
      <p className='px-2 py-4 text-center text-[16px] leading-6 text-[#171923]'>
        Select filters to refine results. Then click on the “Show results”
        button to see matching stories.
      </p>
      <FilterList
        onSelectCategories={handleSelectCategories}
        categoryList={categoryList}
        onSelectedTimeFrame={onSelectedTimeFrame}
        timeFrame={timeFrame.map((el) => Number(el))}
        filterData={filterData}
      />
      <div className='flex h-max flex-row items-center gap-5'>
        <Button
          className='bg-secondary mt-5 h-9 w-16 rounded-sm'
          onClick={onPressBack}
        >
          Back
        </Button>
        <Link
          href={{ pathname: '/searchresults', query: searchParams.toString() }}
        >
          <Button className='bg-secondary mt-5 h-9 w-16 rounded-sm'>
            Next
          </Button>
        </Link>
      </div>
    </div>
  )
}

export default Filters
